<template>
  <div>
    <!-- Banner -->
    <section id="banner" class="parallax">
      <div class="wrapper bg-cover">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="card filter-home">
                <div class="col-md-2; left">
                  <qrcode-vue
                    class="code_crud"
                    size="120"
                    :value="schedule.workstation.id.toString()"
                    level="H"
                  ></qrcode-vue>
                </div>
                <div class="card-body">
                  <div
                    class="row justify-content-center"
                    style="margin-top: 15px; padding-left: 110px"
                  >
                    <div class="col-md-11">
                      <label for="title">Estação de Trabalho</label>
                      <h5>
                        <span class="badge badge-default">{{
                          schedule.place.title
                        }}</span>
                      </h5>
                    </div>
                  </div>
                  <div
                    class="row justify-content-center"
                    style="margin-top: 25px; padding-left: 15px"
                  >
                    <div class="col-md-3">
                      <div class="form-group">
                        <label for="inputPlace">Data Início</label>
                        <h5>
                          <span class="badge badge-default">{{
                            schedule.date_start
                          }}</span>
                        </h5>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group">
                        <label for="inputPlace">Data Final</label>
                        <h5>
                          <span class="badge badge-default">{{
                            schedule.date_end
                          }}</span>
                        </h5>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="form-group">
                        <label for="inputPlace">Status</label>
                        <h5 v-if="schedule.status == 1">
                          <span class="badge badge-default">Reservada</span>
                        </h5>
                        <h5 v-if="schedule.status == 2">
                          <span class="badge badge-primary">Confirmada</span>
                        </h5>
                        <h5 v-if="schedule.status == 3">
                          <span class="badge badge-success">Em andamento</span>
                        </h5>
                        <h5 v-if="schedule.status == 4">
                          <span class="badge badge-warning">Finalizada</span>
                        </h5>
                        <h5 v-if="schedule.status == 5">
                          <span class="badge badge-danger">Cancelada</span>
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card">
                <div class="card-body">
                  <div class="row text-center">
                    <div class="col">
                      <button class="btn btn-success" @click="checkInReserve">
                        Check-in
                      </button>
                    </div>
                    <div class="col">
                      <button class="btn btn-warning" @click="finishReserve">
                        Finalizar
                      </button>
                    </div>
                    <div class="col">
                      <button class="btn btn-danger" @click="cancelReserve">
                        Cancelar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section id="workstations">
      <div class="row justify-content-center">
        <h2 class="title justify-content-center">
          Estação de trabalho reservada
        </h2>
      </div>
      <div class="container-fluid">
        <div class="row justify-content-center">
          <!-- Workstation Card -->
          <div class="col-md-3">
            <div class="card">
              <img class="card-img-top" :src="schedule.workstation.photo" alt />

              <div class="card-body">
                <div class="workstation-name">
                  {{ schedule.place.title }}
                  <span class="workstation-distance">{{
                    schedule.place_id
                  }}</span>
                </div>
                <div class="workstation-info">
                  <div class="workstation-place">
                    {{ schedule.workstation.title }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- <section id="banner" class="parallax" style="margin-top: 25px">
      <div class="wrapper bg-cover">
        <div class="container">
          <div class="row" align="center">
            <div class="col-md-12">
              <h5>Participantes</h5>
              <hr />
            </div>
          </div>
          <div class="row" style="margin-top: -25px; padding: 25px">
            <table class="table table-striped" style="width: 100%">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>E-mail</th>
                  <th>Status</th>
                  <th>QrCode</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="participant in schedule.participants"
                  :key="participant.id"
                >
                  <td width="40%">{{ participant.name }}</td>
                  <td width="40%">{{ participant.email }}</td>
                  <td width="20%">
                    <span
                      class="badge"
                      :class="
                        participant.status == 1
                          ? 'badge-warning'
                          : participant.status == 2
                          ? 'badge-success'
                          : 'badge-danger'
                      "
                      >{{
                        participant.status == 1
                          ? "Aguardando"
                          : participant.status == 2
                          ? "Confirmado"
                          : "Rejeitado"
                      }}</span
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script>
import vSelect from "vue-select";
import QrcodeVue from "qrcode.vue";

export default {
  data: function () {
    return {
      schedule: {
        workstation: [],
      },
    };
  },
  components: { vSelect, QrcodeVue },
  methods: {
    checkInReserve() {
      let self = this;
      let api =
        self.$store.getters.api +
        "schedule_workstations/" +
        self.$route.params.id;
      self.$http
        .put(api, {
          status: 3,
        })
        .then((response) => {
          self.$message(
            "Sucesso",
            "Reserva atualizada com sucesso!",
            "success"
          );
        })
        .then(() => {
          self.schedule.status = 3;
        });
    },
    finishReserve() {
      let self = this;
      let api =
        self.$store.getters.api +
        "schedule_workstations/" +
        self.$route.params.id;
      self.$http
        .put(api, {
          status: 4,
        })
        .then((response) => {
          self.$message(
            "Sucesso",
            "Reserva atualizada com sucesso!",
            "success"
          );
        })
        .then(() => {
          self.schedule.status = 4;
        });
    },
    cancelReserve() {
      let self = this;
      let api =
        self.$store.getters.api +
        "schedule_workstations/" +
        self.$route.params.id;
      self.$http
        .put(api, {
          status: 5,
        })
        .then((response) => {
          self.$message(
            "Sucesso",
            "Reserva atualizada com sucesso!",
            "success"
          );
        })
        .then(() => {
          self.schedule.status = 5;
        });
    },
    getSchedule: function () {
      let self = this;
      let id = self.$route.params.id;
      let api =
        self.$store.state.api +
        "schedule_workstations/" +
        id +
        "/?with[]=workstation&with[]=participants&with[]=place";

      self.$http
        .get(api)

        .then((response) => {
          self.schedule = response.data.data[0];
        })
        .catch((error) => {
          self.errors = error.response.data;
          self.$message(null, self.errors, "error");
        });
    },
  },
  mounted() {
    this.getSchedule();
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.left {
  position: absolute;
  margin-top: 30px;
  margin-right: 950px;
}

.lg-check {
  margin: 20px;
}

.lg-badge {
  margin: 3px;
}

.pointer {
  cursor: pointer;
}

.borderSelected {
  border: 2px solid #222;
  margin-bottom: 1rem;
  box-shadow: inset 0 0 1em #222, 0 0 1em #222;
}

.rowTable {
  border-bottom: 1px solid #222;
  padding: 3px;
  width: 100%;
}

.rowTable:hover {
  border-bottom: 1px solid #222;
  padding: 3px;
  width: 100%;
  background-color: #f0f0f0;
}

input[type="checkbox"] {
  position: absolute;
  z-index: -1;
  opacity: 0;
}

input[type="checkbox"] + label {
  font-size: 12px;
  padding: 2px 0 0;
  width: 100%;
  max-height: 100%;
  border: 2px solid #2b2e2c;
  color: #424241;
  border-radius: 0.25rem;
}

input[type="checkbox"]:checked + label {
  border: 2px solid #474747;
  color: #fff;
  background-color: #474747;
  font-style: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/ScheduleWorkstations/View.vue